import { render, staticRenderFns } from "./PRIQuestions.vue?vue&type=template&id=6d73af9d"
import script from "./PRIQuestions.vue?vue&type=script&lang=js"
export * from "./PRIQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports